/**
 * Permission slug strings — must match Helios-Backend `permissions/slugs.py` (permission_registry.json).
 * Module-level permissions model.
 */

export const CONTRACT_ACCESS = 'contract:access' as const;
export const QUEST_ACCESS = 'quest:access' as const;
export const ADMIN_MANAGE_ROLES = 'admin.manage_roles' as const;
export const ADMIN_MANAGE_USERS = 'admin.manage_users' as const;
export const RISK_ACCESS = 'risk:access' as const;
export const INCIDENT_ACCESS = 'incident:access' as const;
export const THREAT_HUNT_ACCESS = 'threat_hunt:access' as const;
export const BASELINE_SECURITY_ACCESS = 'baseline_security:access' as const;
